import moment from "moment";
import 'moment/locale/fr'

moment.locale('fr')
export function getFilterDateString(date) {
    if (!date) {
        return moment()
            .add(-1, "days")
            .format("YYYY-MM-DD");
    }
    return moment(date.toString()).format("YYYY-MM-DD");
}

export function getFilterStartDateFormatted(date) {
    if (!date) {
        return "";
    }
    return moment(date.toString()).format("LL");
}